/**
 * 读取并抹掉地址栏上的一键登录票据。
 *
 * 不 import 任何东西，好让 main.ts 把它排在最前、尽早执行：票据一次性且 10 秒过期，
 * 留在地址栏只会让用户刷新时拿到「已过期」，换票成功后重载的地址里也不该再有它。
 *
 * 注意：只抹地址栏并不够。vue-router 的 createWebHistory 会另外捕获一份初始地址，
 * 早于它执行也没用——实测首次导航仍会带上 ticket 并顺着 redirect 参数传播，
 * 所以路由守卫里还有一道剔除兜底，两处缺一不可。
 */
const params = new URLSearchParams(window.location.search);
const ticket = params.get('ticket');

if (ticket) {
  params.delete('ticket');
  const search = params.toString();
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`,
  );
}

/** 本次进入页面时地址栏携带的一键登录票据，已从地址栏抹掉；没有则为 null */
export const loginTicket = ticket;
